import React, { useEffect, useState } from "react";
import AuthShell from "@/components/AuthShell";
import { Link, useSearchParams } from "react-router-dom";
import api from "@/lib/api";
import { CheckCircle2, XCircle } from "lucide-react";

export default function VerifyEmail() {
  const [params] = useSearchParams();
  const [status, setStatus] = useState("pending"); // pending | ok | fail

  useEffect(() => {
    const token = params.get("token");
    if (!token) { setStatus("fail"); return; }
    api.post("/auth/verify-email", { token })
      .then(() => setStatus("ok"))
      .catch(() => setStatus("fail"));
  }, [params]);

  return (
    <AuthShell title="Email verification">
      <div className="flex flex-col items-center gap-4 py-6" data-testid="verify-status">
        {status === "pending" && <p className="subtle">Verifying…</p>}
        {status === "ok" && (
          <>
            <CheckCircle2 className="w-12 h-12 text-neu-accent" />
            <p className="heading text-xl">Your email is verified.</p>
            <Link to="/dashboard" className="btn-accent">Go to dashboard</Link>
          </>
        )}
        {status === "fail" && (
          <>
            <XCircle className="w-12 h-12 text-red-500" />
            <p className="heading text-xl">Verification link is invalid.</p>
            <Link to="/signin" className="btn-neu">Back to sign in</Link>
          </>
        )}
      </div>
    </AuthShell>
  );
}
